package com.swetdot.swetgram.cache

import app.cash.sqldelight.Transacter
import app.cash.sqldelight.db.QueryResult
import app.cash.sqldelight.db.SqlDriver
import app.cash.sqldelight.db.SqlSchema
import com.swetdot.swetgram.cache.shared.newInstance
import com.swetdot.swetgram.cache.shared.schema
import kotlin.Unit

public interface SwetgramCache : Transacter {
  public val cacheQueries: CacheQueries

  public companion object {
    public val Schema: SqlSchema<QueryResult.Value<Unit>>
      get() = SwetgramCache::class.schema

    public operator fun invoke(driver: SqlDriver): SwetgramCache = SwetgramCache::class.newInstance(driver)
  }
}
